import React from 'react';
import Hero from '../components/Hero';
import RepairSelector from '../components/RepairSelector';
import CustomControllers from '../components/CustomControllers';
import RetroMods from '../components/RetroMods';
import DeviceBuying from '../components/DeviceBuying';
import FailedRepairs from '../components/FailedRepairs';
import VideoFAQ from '../components/VideoFAQ';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';

function HomePage() {
  return (
    <>
      <Hero />
      <RepairSelector />
      <VideoFAQ />
      <CustomControllers />
      <RetroMods />
      <DeviceBuying />
      <FailedRepairs />
      <FAQ />
      <Contact />
    </>
  );
}

export default HomePage;
